module.exports = __webpack_public_path__ + "r-v3/img/ml_49_01_over.48b556aa.jpg";